import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_ADMIN_ACTIVE_PROJECTS_API } from "./apiRoutes";

interface Props {
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getActiveProjects = async () => {
  return await axiosAuth.get(`${DASHBOARD_ADMIN_ACTIVE_PROJECTS_API}`);
};

const useGetActiveProjects = ({ queryParams }: Props = {}): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-active-projects"],
    queryFn: () => getActiveProjects(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetActiveProjects;
